import { getController } from '@/services/service'

const url = '/roles/permission'
export const permissionService = {
	...getController<
		Api.RolePermission,
		Api.RolePermissionPostInput,
		Api.RolePermissionUpdateRequest
	>(url),
}

export default permissionService
